module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理户外招牌设置备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、员工录用“一件事”主题式情景服务申请表","state":"必要"},{"name":"2、员工信息登记表","state":"必要"},{"name":"3、单位证照","state":"必要"},{"name":"4、授权声明","state":"必要"},{"name":"5、员工身份证正反面","state":"必要"},{"name":"6、单位授权委托书","state":"必要"},{"name":"7、经办人身份证正反面","state":"必要"},{"name":"8、解除劳动合同协议或调档函","state":"必要"},{"name":"9、单位介绍信","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx36.json
// module id = 1333
// module chunks = 0